import { Button } from '@components';
import { Skeleton } from '@atgfr8/atg-ui-tailwind';
import { orderUrls } from '@constants/urls';
import { orderStore } from '@store/orders';
import { OpenInNewIcon } from '@atgfr8/icons';
import { customerPay, totalOrderExpenses } from '@utils/calculateLineItems';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { formatAmount } from '@utils/utils';
import { Show } from 'solid-js';

const HeaderInfo = () => {
  const adjustmentsTotal = () => {
    return orderStore.order.adjustments.reduce(
      (acc, curr) => acc + Number(curr.amount),
      0,
    );
  };

  const profit = () => {
    return (
      Number(customerPay()) -
      Number(totalOrderExpenses()) +
      Number(adjustmentsTotal())
    );
  };

  const margin = () => {
    const calcMargin = (profit() / customerPay()) * 100;

    return !isNaN(calcMargin) && calcMargin != Infinity
      ? calcMargin.toFixed(2)
      : 0;
  };

  const revenue = () => {
    return Number(customerPay()) + Number(adjustmentsTotal());
  };

  return (
    <Show
      when={!orderStore.loading}
      fallback={
        <div class=" flex justify-end pr-4">
          <Skeleton variant="rectangular" height={20} width={200} />
        </div>
      }
    >
      <div class="mobile:flex space-x-2 justify-end font-semibold px-4 text-nowrap items-center overflow-hidden">
        <div class="mobile:flex mobile:text-xs mobile:space-x-1 small-netbook:text-base netbook:text-md">
          <div class="text-base">
            Revenue: {formatAmount(revenue(), { minimumFractionDigits: 2 })}
          </div>
          <div class="text-base">|</div>
          <div class="text-base">Margin: {margin()}%</div>
          <div class="text-base">|</div>
          <div class="text-base">
            Profit: {formatAmount(profit(), { minimumFractionDigits: 2 })}
          </div>
        </div>
        <div class="tablet:block">
          <Show when={orderStore.order.status === 'Void'}>
            <Button
              disableRipple={true}
              // disableElevation={true}
              label="VOID"
              color="error"
              sx={{
                cursor: 'default',
                width: '40px',
                'border-radius': '0px',
                height: '30px',
              }}
              dataTestId={formatDataTestId('VOID', 'button')}
            />
          </Show>
        </div>
        <div>
          <Button
            variant="text"
            disabled={orderStore.isCreate}
            label="View Edit History"
            startIcon={<OpenInNewIcon size={20} />}
            color="info"
            onClick={() => {
              if (!orderStore.isCreate) {
                window.open(
                  orderUrls.editHistory(orderStore.order.id),
                  '_blank',
                );
              }
            }}
            dataTestId={formatDataTestId('View Edit History', 'button')}
          />
        </div>
      </div>
    </Show>
  );
};

export default HeaderInfo;
